/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsFileMusic: {
  name: 'file-music';
  data: string;
} = {
  name: 'file-music',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 2A1.5 1.5 0 0 1 3 .5h10A1.5 1.5 0 0 1 14.5 2v12a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 14V2ZM3 1.5a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5H3Zm4 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM8.5 8a2.5 2.5 0 1 0 1 2V5.618a.5.5 0 0 1 .276-.447l1.448-.724a.5.5 0 1 0-.448-.894l-1.447.723A1.5 1.5 0 0 0 8.5 5.618V8Z" fill="currentColor"/></svg>`,
};
